define('services/myIncentive/myIncentive.service',['app', 'mainCons'], function (app, mainCons) {
    return app.factory('myIncentiveService', ['$q', '$state','$rootScope', 'OpenApp', 'auiDialog', 'ngDialog', 'OpenOther','OpenTrade','modBussService','PartnerMarketSOService','$filter',
        function ($q, $state,$rootScope, OpenApp, auiDialog, ngDialog, OpenOther,OpenTrade,modBussService,PartnerMarketSOService,$filter) {

        var lang = 'zh_CN';
        var queryInspireAppResp;
        function queryInspireApp() {
            var defer = $q.defer();
            if(!queryInspireAppResp){
                OpenOther.queryInspireApp({
                    req: {
                        offerSignStatus: [0, 3],
                        lang: lang,
                        returnAppDetailFlag:1
                    }
                }).then(function (data) {
                    if (data && data.resultCode == 0) {
                        queryInspireAppResp = data;
                        defer.resolve(data);
                    }else{
                        defer.resolve({});
                    }
                }).catch(function (data) {
                    defer.resolve({});
                });
            }else{
                defer.resolve(queryInspireAppResp);
            }
            return defer.promise;
        }
        //清空缓存
        function deletQueryInspireApp() {
            queryInspireAppResp = undefined;
        }

        // 下载发票
        function downloadSelfBillInfos(billID,siteCode,isUrlDownload, docID, fileName) {
            var defer = $q.defer();
            // 弹出下载弹出框 待补充代码
            var req = {
                isUrlDownload:isUrlDownload,
                siteCode: siteCode,
                docID: docID,
                billID: billID
            };
            OpenTrade.getEdmAttachment({req: req}).then(function (resp) {
                if (resp && resp.downloadUrl) {
                    var handler = ngDialog.open({
                        template: 'pages/common/dialog.bill.download.html',
                        className: '',
                        closeByEscape: false,
                        closeByDocument: false,
                        overlay: false,
                        controller: ['$scope', function ($scopeDlg) {
                            $scopeDlg.downloadURL = resp.downloadUrl;
                            $scopeDlg.secret = resp.passCode;
                            $scopeDlg.fileName = fileName;
                            $scopeDlg.callback = function () {
                                handler.close();
                                defer.resolve();
                            };
                            $scopeDlg.close = function () {
                                handler.close();
                                defer.resolve();
                            };
                        }]
                    });
                }
            }).catch(function () {
                defer.reject();
            });
            return defer.promise;
        }
            // 下载结算单和对账明细
            //如果结算单文件返回settlementeDocID则去edoc下载 getEdmAttachment
            //否则bill.billFileName还是调用getAttachment
            function downloadBill(bill, isPDF) {
                var defer = $q.defer();
                var options = {};
                var fileName = [];
                // 下载结算单文件
                if (isPDF==='settlement') {
                    if (bill.settlementeDocID || bill.detailSettlementeObsID) {
                        options.svc = 'getEdmAttachment';
                        options.param = {
                            req: {
                                isUrlDownload: bill.isUrlDownload,
                                siteCode: bill.siteCode,
                                docID: bill.settlementeDocID || bill.detailSettlementeObsID,
                                billID: bill.billID
                            }
                        }
                    } else if (bill.billFileName) {
                        fileName.push(bill.billFileName);
                        options.svc = 'getAttachment';
                        options.param = {
                            req: {
                                fileName: fileName
                            }
                        };
                    }
                } else if(isPDF==='earning'){//对账明细
                    options.svc = 'getEdmAttachment';
                    if(bill.settlementeObsID){
                        options.param = {
                            req: {
                                isUrlDownload: bill.isUrlDownload,
                                siteCode: bill.siteCode,
                                docID: bill.settlementeObsID,
                                billID: bill.billID
                            }
                        }
                    }else {
                        options.param = {
                            req: {
                                isUrlDownload: bill.isUrlDownload,
                                siteCode: bill.siteCode,
                                docID: bill.detailSettlementeDocID,
                                billID: bill.billID
                            }
                        }
                    }
                }else if(isPDF==='sale'){
                    options.svc="getEduOrderDetail";
                    options.param = {
                        req: {
                            startTime: bill.startTime,
                            endTime: bill.endTime
                        }
                    };
                }
                if (!(options && options.svc)) {
                    auiDialog.fail("下载失败", "暂无相关数据。", function () {
                        defer.reject();
                    });
                }else {
                    $rootScope.isCoverShow = true;
                    OpenTrade[options.svc](options.param).then(function (resp) {
                        $rootScope.isCoverShow = false;
                        if (resp  && resp.downloadUrl) {
                            var handler = ngDialog.open({
                                template: 'pages/myreport/download.html',
                                className: '',
                                closeByEscape: false,
                                closeByDocument: false,
                                overlay: false,
                                controller: ['$scope', function ($scopeDlg) {
                                    $scopeDlg.downloadURL = resp.downUrl || resp.downloadUrl || resp.url;
                                    $scopeDlg.secret = resp.zipPassword || resp.passCode;
                                    $scopeDlg.close = function () {
                                        handler.close();
                                        defer.resolve();
                                    };
                                    $scopeDlg.callback = function () {
                                        handler.close();
                                        defer.resolve();
                                    };
                                }]
                            });
                        }
                    }).catch(function (data) {
                        $rootScope.isCoverShow = false;
                        defer.reject();
                    });
                }
                return defer.promise;
            }
            function  downShopBill(bill){
                svc="exportSettledOrderList";
                param = {
                    req: {
                        startTime: $filter('auiSettlementDateFilter')(bill.startTime),
                        endTime: $filter('auiSettlementDateFilter')( bill.endTime)
                    }
                };
                $rootScope.isCoverShow = true;
                PartnerMarketSOService[svc](param).then(function (resp) {
                    $rootScope.isCoverShow = false;
                    if (resp  && resp.result.downUrl) {
                        var handler = ngDialog.open({
                            template: 'pages/myreport/download.html',
                            className: '',
                            closeByEscape: false,
                            closeByDocument: false,
                            overlay: false,
                            controller: ['$scope', function ($scopeDlg) {
                                $scopeDlg.downloadURL = resp.result.downUrl;
                                $scopeDlg.secret = resp.result.zipPassword ;
                                $scopeDlg.close = function () {
                                    handler.close();
                                    defer.resolve();
                                };
                                $scopeDlg.callback = function () {
                                    handler.close();
                                    defer.resolve();
                                };
                            }]
                        });
                    }
                    if(resp && resp.code!=0){
                        auiDialog.fail("请求失败", window.syserrorMsg);
                    }
                }).catch(function (data) {
                    $rootScope.isCoverShow = false;
                    defer.reject();
                });
            }
            // 显示发票列表信息
            function displaySelfBilling(billID, siteCode,isUrlDownload,selfBillingInfos,invoiceInfos) {
                var defer2 = $q.defer();
                ngDialog.open({
                    template: 'pages/myaccount/settlement/account.bill.download.html',
                    className: '',
                    closeByEscape: false,
                    closeByDocument: false,
                    overlay: false,
                    controller: ['$scope', function ($scopeDlg) {
                        $scopeDlg.selfBillingInfos = selfBillingInfos;
                        $scopeDlg.invoiceInfos = invoiceInfos;
                        // 下载协议
                        $scopeDlg.downloadSelfBill = function (docID, fileName) {
                            var defer = $q.defer();
                            downloadSelfBillInfos(billID,siteCode,isUrlDownload, docID, fileName).then(function () {
                                defer.resolve();
                            }).catch(function () {
                                defer.reject();
                            });
                            return defer.promise;
                        };
                        $scopeDlg.close = function () {
                            defer2.resolve();
                            ngDialog.close();
                        };
                    }]
                });
                return defer2.promise;
            }

            function dlgForCurrency(Model,options) {
                var dialog = ngDialog.open({
                    template: '../refactor/pages/myaccount/settlement-dispute/dlgForCurrency.html',
                    className: '',
                    closeByDocument: false,
                    controller: ['$scope', function ($scopeDlg) {
                        $scopeDlg.goBank = function () {
                            dialog.close();
                            $state.go('mysetting.modBussnessInfo', {settlement: 'AccountSettlement'}, {reload: true});
                        };
                        $scopeDlg.confirm = function () {
                            dialog.close();
                            options.cb();
                        };
                        $scopeDlg.close = function () {
                            Model.modifyList = [];
                            Model.checked = {all: false};
                            dialog.close();
                            options.cbForClose();
                        };

                    }]
                });
            }

            function getKitList() {
                var defer = $q.defer();
                var params = {
                    req: {
                        isInspire: 1
                    }
                };
                OpenApp.queryKitList(params).then(function (resp) {
                    var kitList = [];
                    resp.kitInfoList.forEach(function (kitInfo) {
                        if (kitInfo.langInfoDTOMap && kitInfo.langInfoDTOMap[lang]) {
                            kitInfo.langInfo = kitInfo.langInfoDTOMap[lang];
                            kitList.push(kitInfo);
                        }
                    });
                    defer.resolve(kitList);
                });
                return defer.promise;
            }

            function getPromotionItemList(value) {
                var defer = $q.defer();
                var params = {
                    req: {
                        prmtIdList:value,
                        lang:lang
                    }
                };
                OpenOther.getPromotionItemList(params).then(function (resp) {
                    if(resp.prmtItemList && resp.prmtItemList.length>0){
                        defer.resolve(resp.prmtItemList);
                    }
                }).catch(function (resp) {
                    if (resp && resp.NSP_STATUS) {
                        auiDialog.failSystemError($filter('auiErrorCode')(resp.NSP_STATUS));
                    }
                    defer.reject();
                });
                return defer.promise;
            }

            /**
             *  获取时间范围控件配置
             * @param type 时间范围类型
             * @param regionType 时间段类型
             * @returns {{regionType: (*|number), todayCheck: string, startTime: Date, timeQuantum: myIncentiveService.timeQuantum, lastMonth: boolean, regionShow: number[], endTime: Date}}
             */
            function getTimeQuarter(type, regionType) {
                return { // 这里可以什么都不写，直接用默认值
                    regionShow: [12, 11, 5],           //【展示哪些时间段】【默认值】[0,4,5,6]【枚举】 1 今天 2 昨天 3 上周 4 前七天 5 本月 6 上月 7 本周  8 过去一个月 9 过去两个月 10 过去一周 11 过去三个月 12 过去半年
                    regionType: regionType != undefined ? regionType : 5,                  //【时间段】【默认值】0 【枚举】0 自定义1 今天 2 昨天 3 上周 4 前七天 5 本月 6 上月 7 本周  8 过去一个月 9 过去两个月
                    startTime: AUI.DateUtil.calDateByType(type).startDate,           //【开始时间】【默认值】今天 new Date()
                    endTime: AUI.DateUtil.calDateByType(type).endDate,             //【结束时间】【默认值】今天 new Date()
                    timeQuantum: function (timeQuery, newQuery, oldQuery) {
                        var startTime = AUI.DateUtil.getyyyymm(timeQuery.startTime);
                        var endTime = AUI.DateUtil.getyyyymm(timeQuery.endTime);

                        var oldStartTime = AUI.DateUtil.getyyyymm(oldQuery.startTime);
                        var oldEndTime = AUI.DateUtil.getyyyymm(oldQuery.endTime);

                        var startYear = startTime.slice(0, 4);
                        var startMonth = startTime.slice(4, 6);

                        var endYear = endTime.slice(0, 4);
                        var endMonth = endTime.slice(4, 6);

                        var timeQuantum = (endYear * 12 + parseInt(endMonth)) - (startYear * 12 + parseInt(startMonth));

                        if (!AUI.DateUtil.compareDate(startTime, oldStartTime)) {// 如果动了开始时间
                            if (startTime > endTime) {
                                auiDialog.fail("时间区间选择错误", "开始时间不能晚于结束时间。");
                                timeQuery.endTime = AUI.DateUtil.stringToDate(startYear + '-' + startMonth + '-01');
                            } else {
                                if (timeQuantum >= 36) {
                                    auiDialog.fail("时间区间选择错误", "时间跨度不能超过三年。");
                                    timeQuery.endTime = AUI.DateUtil.stringToDate(startYear + '-' + startMonth + '-01');
                                }
                            }
                        } else {// 如果动了结束时间时间
                            if (startTime > endTime) {
                                auiDialog.fail("时间区间选择错误", "开始时间不能晚于结束时间。");
                                timeQuery.startTime = AUI.DateUtil.stringToDate(endYear + '-' + endMonth + '-01');
                            } else {
                                if (timeQuantum >= 36) {
                                    auiDialog.fail("时间区间选择错误", "时间跨度不能超过三年");
                                    timeQuery.startTime = AUI.DateUtil.stringToDate(endYear + '-' + endMonth + '-01');
                                }
                            }
                        }
                    },                 //【允许的时间跨度】默认值是不限制
                    todayCheck: 'N',                //【是否校验开始时间不能等于今天】
                    lastMonth: false   //最大只允许查上个月
                }
            }


        return {
            queryInspireApp:queryInspireApp,
            deletQueryInspireApp:deletQueryInspireApp,
            downloadSelfBillInfos:downloadSelfBillInfos,
            downShopBill: downShopBill,
            downloadBill:downloadBill,
            displaySelfBilling:displaySelfBilling,
            dlgForCurrency:dlgForCurrency,
            getKitList:getKitList,
            getPromotionItemList:getPromotionItemList,
            getTimeQuarter:getTimeQuarter,
        }
    }]);
});


